import TaxonomyAdminScreen from "../taxonomy/taxonomy-admin-screen.tsx";

export default function ActorsScreen() {
  return <TaxonomyAdminScreen type="actors" title="بازیگران" />;
}
